import { useEffect } from "react";
import { FaPlus } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store.ts";
import List from "../../components/CoreComponents/List.tsx";
import { IoBusinessOutline } from "react-icons/io5";
import { getProjectText } from "../../types/types.ts";
import { useNavigate } from "react-router-dom";
import storeAdHocUnits from "../../components/DownloadManager/storeAdHocUnits.tsx";
import { updateDownloadTriggered } from "../../store/Utilities.ts";
import Loader from "../../components/CoreComponents/Loader.tsx";
import { HiRefresh } from "react-icons/hi";

export default function AllAdHocUnits() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { projects } = useSelector((state: RootState) => state.Project);
    const { ProjectAdHocItem } = useSelector((state: RootState) => state.AdHocUnit);
    const { hasDownloaded: { adHocUnits: hasDownloadedAdHoc } } = useSelector(
        (state: RootState) => state.Utilities
    );

    // Trigger adhoc download on mount if not already downloaded
    useEffect(() => {
        if (!hasDownloadedAdHoc) {
            dispatch(updateDownloadTriggered({ key: "adHocUnits", value: true }));
        }
    }, []);

    const { isLoading } = storeAdHocUnits();

    const handleRefresh = () => {
        if (!navigator.onLine) return;
        dispatch(updateDownloadTriggered({ key: "adHocUnits", value: true }));
    };
    
    const filteredProjectAdHocUnitItem = Object.entries(ProjectAdHocItem)
        .reduce((acc, [project, items]) => {
            if (items.length !== 0 && ProjectAdHocItem[project]) {
                acc[project] = ProjectAdHocItem[project];
            }
            return acc;
        }, {});

    if (isLoading) {
        return <Loader loaders={{ isAdHocUnitsLoading: true }} />;
    }
        
    return (
        <>
            <div className="max-w-screen-lg">
                <div className={'flex items-center'}>
                    <div className='w-full text-xl font-semibold uppercase text-center mt-4 mb-4'>AdHoc Items</div>
                    <button
                        onClick={handleRefresh}
                        disabled={isLoading || !navigator.onLine}
                        className="flex items-center gap-2 px-3 py-1.5 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed mr-2"
                        title={!navigator.onLine ? 'You are offline' : 'Refresh adhoc items'}
                    >
                        <HiRefresh size={18} className={isLoading ? 'animate-spin' : ''} />
                        <span className="whitespace-nowrap text-sm font-medium">Refresh</span>
                    </button>
                    <button
                        type="button"
                        className="bg-[#fdb419] float-right whitespace-nowrap"
                        title="Add Unit"
                        onClick={() => navigate(`/AdHocUnits/Create`)}>
                        <span className="flex gap-1 items-center text-sm font-medium text-white">
                            <FaPlus size={18} />
                            <span className="ml-0">Add AdHoc Checklist Item</span>
                        </span>
                    </button>
                </div>
                <List<any>
                    name="ad-hock-unit-project"
                    data={Object.keys(filteredProjectAdHocUnitItem)}
                    rowHoverClassName="hover:bg-orange-1000 hover:text-white hover:cursor-pointer"
                    renderChildItem={(project: number) => () => {
                        return (ProjectAdHocItem[project].length != 0 ?
                            <div className={`flex items-center`}>
                                <IoBusinessOutline className="w-10 h-10 text-uniteOrange group-hover:text-white" />
                                <div className="ml-2">
                                    <h2>{getProjectText(projects.find(p => p.projectNumber === Number(project)))}</h2>
                                    <span>{ProjectAdHocItem[project].length} Created AdHoc Items</span>
                                </div>
                            </div> : '')

                    }}
                    onClick={(project) => navigate(`/AdHocUnits/${project}`)}
                    isItemDisabled={false}
                />
            </div>
        </>
    );
}
